import React from 'react';

const Loading = () => {
    return (
        <div className='flex justify-center items-center h-[100vh]'>
            <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin dark:border-indigo-400"></div>
        </div>
    );
};

export default Loading;